import AddCardMethodModal from './AddCardMethodModal.component';

export default AddCardMethodModal;
